module.exports = __webpack_public_path__ + "media/img/Instagram_logo-f7b3dff34fba7bf43d83022425cb2ef3.png";